import React from 'react'
import { object } from 'prop-types'
import { css } from '@emotion/react'

import { canUseWindow } from '@/utils/browser'
import useInViewport from '@/hooks/useInViewport'
import mediaQueries from '@/layout/media-queries'
import ProductBreadcrumbs from '@/components/Product/Breadcrumbs'
import ExpertBreadcrumbs from '@/components/Expert/Breadcrumbs'
import AppActionButton from '@/components/Product/Action'
import DeveloperBreadcrumbs from '@/components/Developer/Breadcrumbs'

const breadcrumbsWrapperCss = ({ layout, spacing }) => css`
  border-top: 1px solid ${layout.breadcrumbs.borderColor};
  border-bottom: 1px solid ${layout.breadcrumbs.borderColor};
  width: calc(100% + 32px);
  margin-left: -${spacing.s};
  margin-right: -${spacing.s};
  padding-left: 0;
  padding-right: 0;

  ${mediaQueries.smallScreen()} {
    padding-left: ${spacing.m};
    padding-right: ${spacing.m};
    width: calc(100% + 64px);
    margin-left: -${spacing.m};
    margin-right: -${spacing.m};
  }

  > div {
    ${mediaQueries.mediumScreen(100)} {
      display: none;
    }
  }

  ${mediaQueries.mediumScreen(100)} {
    display: none;
  }
`

const breadcrumbsContentCss = ({ maxWidth, spacing }) => css`
  padding: 0;
  margin: 0 auto;
  max-width: ${maxWidth};
  margin: 0 auto;
  width: 100%;

  ${mediaQueries.smallScreen()} {
    padding: 0 ${spacing.s};
  }

  > div {
    border-bottom: none;
  }
`

const actionButtonCss = css`
  margin-left: 15px;
`

const BreadcrumbsWrapper = ({ app, category, service, expert, developer }) => {
  const isActionButtonVisible = useInViewport('#action-btn-app', {
    offsetTop: -105,
    disable: !app,
  })

  const isExpertsView =
    canUseWindow && String(window.location.pathname).includes('/partners')

  const isDeveloperView =
    canUseWindow && String(window.location.pathname).includes('/developers')

  const getActionButton = (app) => {
    if (
      typeof isActionButtonVisible === 'undefined' ||
      isActionButtonVisible ||
      !app
    ) {
      return null
    }

    return (
      <div css={actionButtonCss}>
        <AppActionButton
          id={app.id}
          useActionQuery={false}
          fullWidth={false}
          onlyPrimaryButton
          size="compact"
        />
      </div>
    )
  }

  if (app || category || service) {
    return (
      <div css={breadcrumbsWrapperCss}>
        <div css={breadcrumbsContentCss}>
          <ProductBreadcrumbs
            category={category}
            {...app}
            {...service}
            isServiceView={!!service}
            actions={getActionButton(app)}
          />
        </div>
      </div>
    )
  }

  if (expert || isExpertsView) {
    return (
      <div css={breadcrumbsWrapperCss}>
        <div css={breadcrumbsContentCss}>
          <ExpertBreadcrumbs expert={expert} />
        </div>
      </div>
    )
  }

  if (developer || isDeveloperView) {
    return (
      <div css={breadcrumbsWrapperCss}>
        <div css={breadcrumbsContentCss}>
          <DeveloperBreadcrumbs developer={developer} />
        </div>
      </div>
    )
  }

  return null
}

BreadcrumbsWrapper.propTypes = {
  app: object,
  service: object,
  expert: object,
  category: object,
  developer: object,
}

export default BreadcrumbsWrapper
